import { FC, Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import { Audience } from '@/models/audiences';
import { Divider } from '@/components/divider';
import { mapAudienceExpressionToRules } from '@/utils';
import { RuleRender } from '../../../rules';
import { PlusCircleIcon } from '@heroicons/react/outline';
import { isLastItemArray } from '@/utils/isLastItemArray';
import { PropertyOperations } from '@/services/endpoints/audiences';

interface IUsedRulesSection {
  audience: Audience;
  propertyOperations: PropertyOperations;
}

export const UsedRulesSection: FC<IUsedRulesSection> = ({ audience, propertyOperations }) => {
  const { t } = useTranslation();
  const rules = mapAudienceExpressionToRules(audience.expression);

  return (
    <div className='flex flex-col gap-2'>
      <p className='inline-block text-base font-semibold text-brand-600'>{t('audience_details:slideover.rules_used')}</p>
      {rules.map((rule, ruleIndex, ruleArr) => {
        return (
          <Fragment key={rule.id}>
            <div className='rounded-lg border border-quaternary-300'>
              {rule.expressions.map((expression, expressionIndex, expressionArr) => {
                return (
                  <div key={expressionIndex}>
                    <div className='flex flex-col justify-center p-3'>
                      <RuleRender expression={expression} propertyOperations={propertyOperations} />
                    </div>
                    {!isLastItemArray(expressionIndex, expressionArr) && (
                      <div className='flex'>
                        <h6 className='px-[10px] text-[10px] text-quaternary-500'>{t('audience:rules.or')}</h6>
                        <Divider />
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
            {!isLastItemArray(ruleIndex, ruleArr) && (
              <div className='flex gap-[10px]'>
                <Divider />
                <PlusCircleIcon className='size-5 shrink-0 text-tertiary-600' />
                <Divider />
              </div>
            )}
          </Fragment>
        );
      })}
    </div>
  );
};
